/** The slice of a Refine `TreeMenuItem` the key helpers read. */
export interface MenuKeyNode {
  key?: string;
  list?: unknown;
  children: MenuKeyNode[];
}

/**
 * A resource with its own list page *and* child resources renders as a
 * `SubMenu`, whose title cannot be a link — so the sider adds a first child
 * pointing at the parent's list. This is that child's menu key.
 */
export const parentListKey = (key: string): string => `${key}::list`;

/** True when the node needs the synthetic "parent list" child. */
export const hasParentListItem = (node: MenuKeyNode): boolean =>
  node.children.length > 0 && Boolean(node.list);

const findNode = (
  nodes: MenuKeyNode[],
  key: string
): MenuKeyNode | undefined => {
  for (const node of nodes) {
    if (node.key === key) return node;
    const found = findNode(node.children, key);
    if (found) return found;
  }
  return undefined;
};

/**
 * `useMenu` selects the resource's own key, which for a parent-with-list is
 * the `SubMenu` — antd highlights nothing for it. Redirect the selection to
 * the synthetic list child; every other key passes through untouched.
 */
export const resolveSelectedKey = (
  menuItems: MenuKeyNode[],
  selectedKey?: string
): string | undefined => {
  if (!selectedKey) return selectedKey;
  const node = findNode(menuItems, selectedKey);
  return node && hasParentListItem(node)
    ? parentListKey(selectedKey)
    : selectedKey;
};
